module.exports = __webpack_public_path__ + "img/fa-solid-900.84de9483.svg";